import React, { useContext, useState } from "react";
import { Plus, Save, Trash2, X } from "lucide-react";

import { postData } from "../../../../services/Fetchnodeservices";
import { ThemeContext } from "../../../../context/ThemeContext";
import ImageSearchModal from "./ImageSearchModal";

const AddItemModal = ({
  isOpen,
  onClose,
  designationId,
  designation_id,
  onSuccess,
  markupCommission = 20,
  profitCommission = 20,
}) => {
  const { theme, currentTheme } = useContext(ThemeContext) || {};
  const isDark = currentTheme === "dark";

  const ts = {
    background: theme?.background || (isDark ? "#0f172a" : "#f8fafc"),
    surface: theme?.surface || (isDark ? "#1e293b" : "#ffffff"),
    surfaceLighter:
      theme?.surfaceLighter || (isDark ? "#334155" : "#f1f5f9"),
    border: theme?.border || (isDark ? "#475569" : "#e2e8f0"),
    textPrimary: theme?.textPrimary || (isDark ? "#f8fafc" : "#0f172a"),
    textSecondary: theme?.textSecondary || (isDark ? "#cbd5e1" : "#334155"),
    textMuted: theme?.textMuted || (isDark ? "#94a3b8" : "#64748b"),
    primary: theme?.primary || "#6366f1",
    primaryLight: theme?.primaryLight || "rgba(99,102,241,0.15)",
    success: theme?.success || "#10b981",
    error: theme?.error || "#ef4444",
    gradient:
      theme?.primaryGradient ||
      `linear-gradient(135deg, ${theme?.primary || "#6366f1"}, ${
        theme?.primaryDark || theme?.primary || "#8b5cf6"
      })`,
  };

  const activeDesignationId = designationId || designation_id;

  const initialForm = {
    name: "",
    description: "",
    is_veg: "yes",
    pic1: "",
    base_price: "",
    variants: [],
  };

  const [formData, setFormData] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [showImageFinder, setShowImageFinder] = useState(false);

  const calculatePrices = (menuPrice) => {
    const menu = parseFloat(menuPrice) || 0;
    const customer = Math.round(menu * (1 + markupCommission / 100));
    const profit = Math.round(customer * (profitCommission / 100));
    const vendor = customer - profit;

    return { menu, customer, vendor, profit };
  };

  const resetAndClose = () => {
    setFormData(initialForm);
    onClose();
  };

  const addVariant = () => {
    setFormData((previous) => ({
      ...previous,
      variants: [
        ...previous.variants,
        { unit_value: "", actual_price: "" },
      ],
    }));
  };

  const updateVariant = (index, changes) => {
    setFormData((previous) => ({
      ...previous,
      variants: previous.variants.map((variant, variantIndex) =>
        variantIndex === index
          ? { ...variant, ...changes }
          : variant
      ),
    }));
  };

  const removeVariant = (index) => {
    setFormData((previous) => ({
      ...previous,
      variants: previous.variants.filter(
        (_, variantIndex) => variantIndex !== index
      ),
    }));
  };

//   const handleSave = async () => {
//     if (!formData.name.trim()) {
//       alert("Dish name is required.");
//       return;
//     }

//     if (!activeDesignationId) {
//       alert("Restaurant ID not found.");
//       return;
//     }

//     const menuPrice = parseFloat(formData.base_price) || 0;

//     if (!menuPrice && formData.variants.length === 0) {
//       alert("Please enter a menu price or add a variant.");
//       return;
//     }

//     setSaving(true);

//     try {
//       const formattedVariants = formData.variants
//         .filter((variant) => variant.unit_value || variant.actual_price)
//         .map((variant) => {
//           const prices = calculatePrices(variant.actual_price);

//           return {
//             unit: (variant.unit_value || "Price").toLowerCase(),
//             unit_value: variant.unit_value || "Price",
//             base_price: prices.menu,
//             actual_price: prices.menu,
//             item_price_variant: prices.customer,
//             price: prices.customer,
//             is_available_variant: "yes",
//           };
//         });

//       const mainPrice =
//         formattedVariants.length > 0
//           ? formattedVariants[0].actual_price
//           : menuPrice;

//       const mainCustomerPrice =
//         formattedVariants.length > 0
//           ? formattedVariants[0].item_price_variant
//           : calculatePrices(menuPrice).customer;

//       const newItem = {
//         name: formData.name.trim(),
//         description: formData.description.trim(),
//         is_veg: formData.is_veg,
//         pic1: formData.pic1,
//         base_price: mainPrice,
//         requested_price: mainPrice,
//         price: mainCustomerPrice,
//         variant: formattedVariants,
//         status: "1",
//         source: "manual",
//       };

//       const response = await postData(
//         `menu/direct-items/${activeDesignationId}`,
//         { items: [newItem] }
//       );

//       if (response?.success) {
//         onSuccess?.();
//         resetAndClose();
//       } else {
//         alert(response?.message || "Item add nahi hua.");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Item add karte time error aaya.");
//     } finally {
//       setSaving(false);
//     }
//   };


const handleSave = async () => {
  if (!formData.name?.trim()) {
    alert("Dish name is required.");
    return;
  }

  if (!activeDesignationId) {
    alert("Restaurant ID not found.");
    return;
  }

  const normalMenuPrice = parseFloat(formData.base_price) || 0;

  // Convert UI variants into the backend's required format.
  const formattedVariants = (formData.variants || [])
    .filter(
      (variant) =>
        variant.unit_value?.trim() ||
        parseFloat(variant.actual_price) > 0
    )
    .map((variant) => {
      const menuPrice = parseFloat(variant.actual_price) || 0;
      const prices = calculatePrices(menuPrice);

      return {
        unit: (variant.unit_value || "Regular").toLowerCase(),
        unit_value: variant.unit_value || "Regular",

        // Original menu price
        base_price: menuPrice,
        actual_price: menuPrice,
        requested_price: menuPrice,

        // Customer/app price
        item_price_variant: prices.customer,
        price: prices.customer,

        is_available_variant: "yes",
      };
    });

  if (!normalMenuPrice && formattedVariants.length === 0) {
    alert("Please enter a menu price or add at least one variant.");
    return;
  }

  // If variants exist, the first variant becomes the item's default price.
  const defaultMenuPrice =
    formattedVariants.length > 0
      ? formattedVariants[0].actual_price
      : normalMenuPrice;

  const defaultCustomerPrice =
    formattedVariants.length > 0
      ? formattedVariants[0].item_price_variant
      : calculatePrices(normalMenuPrice).customer;

  const newItem = {
    // Required so Edit and Delete work for manually added items.
    product_id: `manual_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 8)}`,

    name: formData.name.trim(),
    description: formData.description?.trim() || "",
    is_veg: formData.is_veg || "yes",
    pic1: formData.pic1 || "",

    base_price: defaultMenuPrice,
    requested_price: defaultMenuPrice,
    price: defaultCustomerPrice,

    // IMPORTANT: variants are stored using `variant`, not `variants`.
    variant: formattedVariants,

    status: "1",
    source: "manual",
  };

  setSaving(true);

  try {
    // Correct manual-add backend route.
    const response = await postData(
      `restaurant/add-item/${activeDesignationId}`,
      newItem
    );

    if (response?.success) {
      onSuccess?.();
      resetAndClose();
    } else {
      alert(response?.message || "Item save nahi hua.");
    }
  } catch (error) {
    console.error("Manual item save failed:", error);
    alert("Item save karte waqt error aaya.");
  } finally {
    setSaving(false);
  }
};

if (!isOpen) return null;

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "12px",
    borderRadius: "10px",
    background: ts.background,
    border: `1px solid ${ts.border}`,
    color: ts.textPrimary,
    outline: "none",
    fontSize: "14px",
  };

  return (
    <div
      onClick={resetAndClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        background: "rgba(0,0,0,0.72)",
        backdropFilter: "blur(5px)",
      }}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: "580px",
          maxHeight: "90vh",
          overflowY: "auto",
          background: ts.surface,
          border: `1px solid ${ts.border}`,
          borderRadius: "20px",
          color: ts.textPrimary,
          boxShadow: "0 20px 45px rgba(0,0,0,0.3)",
        }}
      >
        <div
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: `1px solid ${ts.border}`,
          }}
        >
          <h3 style={{ margin: 0 }}>➕ Add New Item</h3>

          <button
            type="button"
            onClick={resetAndClose}
            style={{
              background: "none",
              border: "none",
              color: ts.textMuted,
              cursor: "pointer",
            }}
          >
            <X />
          </button>
        </div>

        <div style={{ padding: "20px" }}>
          <label style={{ fontSize: "12px", color: ts.textMuted }}>
            Dish Name *
          </label>
          <input
            style={{ ...inputStyle, marginTop: "6px", marginBottom: "16px" }}
            placeholder="Example: Paneer Butter Masala"
            value={formData.name}
            onChange={(event) =>
              setFormData({ ...formData, name: event.target.value })
            }
          />

          <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "12px", color: ts.textMuted }}>
                Food Type
              </label>

              <select
                style={{ ...inputStyle, marginTop: "6px" }}
                value={formData.is_veg}
                onChange={(event) =>
                  setFormData({ ...formData, is_veg: event.target.value })
                }
              >
                <option value="yes">🥬 Veg</option>
                <option value="no">🍖 Non-Veg</option>
              </select>
            </div>

            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "12px", color: ts.textMuted }}>
                Menu Price ₹
              </label>

              <input
                type="number"
                style={{ ...inputStyle, marginTop: "6px" }}
                placeholder="Example: 250"
                value={formData.base_price}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    base_price: event.target.value,
                  })
                }
              />
            </div>
          </div>

          {formData.base_price && (
            <div
              style={{
                padding: "10px",
                marginBottom: "16px",
                borderRadius: "10px",
                background: ts.primaryLight,
                color: ts.textSecondary,
                fontSize: "12px",
              }}
            >
              Customer pays:{" "}
              <strong style={{ color: ts.primary }}>
                ₹{calculatePrices(formData.base_price).customer}
              </strong>
              {" · "}
              Vendor gets:{" "}
              <strong style={{ color: ts.success }}>
                ₹{calculatePrices(formData.base_price).vendor}
              </strong>
            </div>
          )}

          <label style={{ fontSize: "12px", color: ts.textMuted }}>
            Description
          </label>
          <textarea
            rows="3"
            style={{
              ...inputStyle,
              marginTop: "6px",
              marginBottom: "16px",
              resize: "vertical",
            }}
            placeholder="Short description..."
            value={formData.description}
            onChange={(event) =>
              setFormData({
                ...formData,
                description: event.target.value,
              })
            }
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <label style={{ fontSize: "12px", color: ts.textMuted }}>
              Item Image
            </label>

            <button
              type="button"
              onClick={() => setShowImageFinder(true)}
              style={{
                background: ts.primaryLight,
                color: ts.primary,
                border: "none",
                cursor: "pointer",
                borderRadius: "8px",
                padding: "7px 10px",
                fontWeight: 600,
                fontSize: "12px",
              }}
            >
              ✨ Find Image
            </button>
          </div>

          {formData.pic1 && (
            <img
              src={formData.pic1}
              alt="Selected dish"
              style={{
                width: "90px",
                height: "90px",
                objectFit: "cover",
                borderRadius: "10px",
                border: `1px solid ${ts.border}`,
                marginBottom: "16px",
              }}
            />
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "8px",
              marginBottom: "10px",
            }}
          >
            <strong style={{ fontSize: "13px" }}>Variants (optional)</strong>

            <button
              type="button"
              onClick={addVariant}
              style={{
                color: ts.primary,
                background: "none",
                border: "none",
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              <Plus size={14} style={{ verticalAlign: "middle" }} /> Add Variant
            </button>
          </div>

          {formData.variants.map((variant, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                padding: "10px",
                marginBottom: "8px",
                borderRadius: "10px",
                border: `1px solid ${ts.border}`,
                background: ts.surfaceLighter,
              }}
            >
              <input
                style={{ ...inputStyle, flex: 1.5 }}
                placeholder="Half / Full"
                value={variant.unit_value}
                onChange={(event) =>
                  updateVariant(index, {
                    unit_value: event.target.value,
                  })
                }
              />

              <input
                type="number"
                style={{ ...inputStyle, flex: 1 }}
                placeholder="Menu ₹"
                value={variant.actual_price}
                onChange={(event) =>
                  updateVariant(index, {
                    actual_price: event.target.value,
                  })
                }
              />

              <button
                type="button"
                onClick={() => removeVariant(index)}
                style={{
                  border: "none",
                  background: "none",
                  color: ts.error,
                  cursor: "pointer",
                }}
              >
                <Trash2 size={17} />
              </button>
            </div>
          ))}
        </div>

        <div
          style={{
            padding: "20px",
            display: "flex",
            gap: "10px",
            borderTop: `1px solid ${ts.border}`,
          }}
        >
          <button
            type="button"
            onClick={resetAndClose}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "10px",
              border: `1px solid ${ts.border}`,
              background: ts.surfaceLighter,
              color: ts.textSecondary,
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              flex: 2,
              padding: "12px",
              border: "none",
              borderRadius: "10px",
              background: ts.gradient,
              color: "#ffffff",
              cursor: saving ? "not-allowed" : "pointer",
              fontWeight: 700,
              opacity: saving ? 0.7 : 1,
            }}
          >
            <Save size={16} style={{ verticalAlign: "middle" }} />{" "}
            {saving ? "Adding..." : "Add Item"}
          </button>
        </div>
      </div>

      {showImageFinder && (
        <div onClick={(event) => event.stopPropagation()}>
          <ImageSearchModal
            isOpen={showImageFinder}
            onClose={() => setShowImageFinder(false)}
            query={formData.name}
            onSelect={(imageUrl) => {
              setFormData({ ...formData, pic1: imageUrl });
              setShowImageFinder(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AddItemModal;